import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectConversationSortOrderOption')(function selectConversationSortOrderOption(sortOrder, state) {
    var optionState = state.optionState;
    optionState.conversationSortOrder = sortOrder;
}));
//# sourceMappingURL=selectConversationSortOrderOption.js.map